import * as echarts from 'echarts';
export default {
  name: "accuracyBarChart",
  props: {
    data: {
      type: Array,
      default: () => {
        return [20];
      }
    }
  },
  watch: {
    data() {
      this.$nextTick(() => this.render());
    }
  },
  methods: {
    render() {
      let option = {
        title: {
          text: '正确率',
          subtext: '综合你的当前成绩、历史成绩及平台历史做题成绩'
        },
        legend: {
          bottom: 'bottom',
          left: 'center',
          itemStyle: {
            color: '#F68D2B'
          }
        },
        xAxis: [{
          type: 'category',
          // prettier-ignore
          data: ['本次正确率', '历史正确率', '平台正确率']
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: 100
        }],
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return '<div><span style="color:#FF5733">录取率最高：100%</span> </div>' + '<div><span style="color:#FFD700">录取率最低：80%</span> </div>' + '<div><span style="color:#77DD77">' + params[0]?.data?.name + '：' + params[0]?.data?.value + '%</span></div>';
          }
        },
        series: [{
          name: '正确率',
          type: 'bar',
          data: [{
            value: this.data[0],
            name: '本次正确率',
            itemStyle: {
              color: '#F68D2B'
            }
          }, {
            value: this.data[1],
            name: '历史正确率',
            itemStyle: {
              color: '#F68D2B'
            }
          }, {
            value: this.data[2],
            name: '平台正确率',
            itemStyle: {
              color: '#F68D2B'
            }
          }],
          markLine: {
            data: [{
              name: '通过率最高水平线',
              yAxis: 100,
              itemStyle: {
                color: '#FF5733'
              }
            }, {
              name: '通过率最低水平线',
              yAxis: 80,
              itemStyle: {
                color: '#FFD700'
              }
            }]
          },
          label: {
            show: true,
            // 显示标签
            position: 'inside',
            formatter: '{c}%',
            textStyle: {
              color: 'black'
            }
          }
        }]
      };
      let pie = document.getElementById('accuracyBarChart');
      let exist = echarts.getInstanceByDom(pie);
      if (exist) {
        console.log(this.id, '销毁已存在的');
        exist.dispose();
      }
      let chart = echarts.init(pie);
      chart.setOption(option);
    },
    init() {
      this.$nextTick(() => this.render());
    }
  },
  mounted() {
    this.init();
  }
};